import { Box } from '@mui/material';

import { PrimaryInternalFuelingStatus } from '@ocx-app/modules/transaction/types';

import { Typography, SizingMultiplier } from '@ocx/ui';
import { useAsset } from '@ocx/data-configuration';

import { FuelingStatusAction } from './fueling-status-action.component';

type FuelingStatusProps = {
  status: PrimaryInternalFuelingStatus;
  label: string;
  secondaryLabel: string | null;
  navigateToReceipt(): void;
  navigateToHome(): void;
};

export const FuelingStatus = (props: FuelingStatusProps) => {
  const { status, label, secondaryLabel, navigateToReceipt, navigateToHome } = props;

  const fuelingProcessSrc = useAsset('FuelingProcess');
  const fuelingCompletedSrc = useAsset('FuelingCompleted');

  return (
    <Box display="flex" flexGrow={1} flexDirection="column" alignItems="center" mt={18}>
      <Box
        component="img"
        width={100}
        height={100}
        mb={SizingMultiplier.lg}
        src={status === PrimaryInternalFuelingStatus.CompletedSuccessfully ? fuelingCompletedSrc : fuelingProcessSrc}
        alt="fueling-logo"
      />
      <Box mb={SizingMultiplier.md}>
        <Typography variant="h5" gutterBottom align="center">
          {label}
        </Typography>
        {secondaryLabel && (
          <Typography variant="body1" color="textSecondary" align="center" maxWidth={300}>
            {secondaryLabel}
          </Typography>
        )}
      </Box>
      <FuelingStatusAction status={status} navigateToReceipt={navigateToReceipt} navigateToHome={navigateToHome} />
    </Box>
  );
};
